module.exports = __webpack_public_path__ + "static/media/gst-input-logo-alone.b35b5276.png";